import { twMerge } from 'tailwind-merge';
import React, { MouseEventHandler } from 'react';
import Icon, { IconKey } from '../ui-components/Icon';

interface Props {
    iconKey: IconKey;
    onClick?: MouseEventHandler;
}

const PbxMenuIcon = ({ iconKey, onClick }: Props) => (
    <div
        className={twMerge(
            'flex items-center justify-center rounded-xl bg-gray-200 p-1.5 text-gray-600',
            onClick ? 'cursor-pointer hover:bg-gray-300' : null,
        )}
        onClick={onClick}
    >
        <Icon iconKey={iconKey} />
    </div>
);

export default PbxMenuIcon;
